/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Dnc_FilteringInputs */

const en_svchip_dnc_filtering = /** @type {(inputs: Svchip_Dnc_FilteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DNC filtering`)
};

const ar_svchip_dnc_filtering = /** @type {(inputs: Svchip_Dnc_FilteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تصفية قوائم الحظر`)
};

const bn_svchip_dnc_filtering = /** @type {(inputs: Svchip_Dnc_FilteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ডিএনসি ফিল্টারিং`)
};

const de_svchip_dnc_filtering = /** @type {(inputs: Svchip_Dnc_FilteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sperrlistenfilter`)
};

const es_svchip_dnc_filtering = /** @type {(inputs: Svchip_Dnc_FilteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtro de listas de exclusión`)
};

const fr_svchip_dnc_filtering = /** @type {(inputs: Svchip_Dnc_FilteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtre de listes d'exclusion`)
};

const pt_svchip_dnc_filtering = /** @type {(inputs: Svchip_Dnc_FilteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtro de listas de exclusão`)
};

const zh_svchip_dnc_filtering = /** @type {(inputs: Svchip_Dnc_FilteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免打扰过滤`)
};

const tr_svchip_dnc_filtering = /** @type {(inputs: Svchip_Dnc_FilteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arama engel listesi filtresi`)
};

const ru_svchip_dnc_filtering = /** @type {(inputs: Svchip_Dnc_FilteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Фильтр стоп-списков`)
};

const pl_svchip_dnc_filtering = /** @type {(inputs: Svchip_Dnc_FilteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtr list zakazu`)
};

/**
* | output |
* | --- |
* | "DNC filtering" |
*
* @param {Svchip_Dnc_FilteringInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_dnc_filtering = /** @type {((inputs?: Svchip_Dnc_FilteringInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Dnc_FilteringInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_dnc_filtering(inputs)
	if (locale === "bn") return bn_svchip_dnc_filtering(inputs)
	if (locale === "de") return de_svchip_dnc_filtering(inputs)
	if (locale === "es") return es_svchip_dnc_filtering(inputs)
	if (locale === "fr") return fr_svchip_dnc_filtering(inputs)
	if (locale === "pt") return pt_svchip_dnc_filtering(inputs)
	if (locale === "zh") return zh_svchip_dnc_filtering(inputs)
	if (locale === "tr") return tr_svchip_dnc_filtering(inputs)
	if (locale === "ru") return ru_svchip_dnc_filtering(inputs)
	if (locale === "pl") return pl_svchip_dnc_filtering(inputs)
	return en_svchip_dnc_filtering(inputs)
});